module.exports = __webpack_public_path__ + "img/Man-2.d5e2f5b5.svg";